import textStyles from '../TextMenu.module.css'
import exMNP from "../../Img/Menu/MNP/exMNP.png";
import exSTEP1 from "../../Img/Menu/MNP/exSTEP1.png";
import exSTEP2 from "../../Img/Menu/MNP/exSTEP2.png";
import exPAYMENT from "../../Img/Menu/Payment/exPaymentType.png";
import {useDispatch} from "react-redux";
import {setMainMenuId} from "../../Reducer/GlobalReducer";
import {Helmet} from "react-helmet";
import React from "react";
export default function MenuMNP()
{
    const vidWidth =  window.innerWidth-60 < 720 ? window.innerWidth-60 : 720
    const dispatch = useDispatch()
    dispatch(setMainMenuId(8))
    return(
        <div className={textStyles.mainCont}>
            <Helmet>
                <title>sim-unlim : Переход со своим номером (MNP)</title>
                <link rel="canonical" href="https://sim-unlim.com/mnp" />
                <meta name="description" content="МНП MNP переход перенос паспотр прописка заявление" />
            </Helmet>
            <div className={textStyles.blCont}>
                <div className={textStyles.head}><p >Переход со своим номером (MNP)</p></div>
                <p className={textStyles?.ident}>
                    На некоторые тарифы можно подключиться со своим номером, используя процедуру MNP - перенос номера от одного оператора к другому.
                </p>

                <div className={textStyles.vidCont}>
                    <iframe width={vidWidth} height={vidWidth/1.77}  src="https://rutube.ru/play/embed/5fdf0aa56503dc265f97163568a3c49b/" style={{border:"none"}} allow="clipboard-write; webkitAllowFullScreen;mozallowfullscreen"   allowFullScreen></iframe>

                </div>


                <p><span className={textStyles.bold}>Для чего это делается</span>
                </p>
                <div className={textStyles.lsCont}>
                    <ul>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Перейти на более выгодный тариф, которого нет у Вашего оператора</div>
                            </div>
                        </li>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Улучшить качество связи </div>
                            </div>
                        </li>
                    </ul>

                </div>

                <div className={textStyles.cenCont}><p className={textStyles.bold}>Как проходит процедура MNP</p></div>
                <div className={textStyles.cenCont}>
                    <div className={textStyles.imgCont}>
                        <img className={textStyles.widthImg} src={exMNP}></img>
                        <div className={textStyles.imgTitle}>Рисунок 1. (Шаги процедуры MNP)</div>
                    </div>
                </div>
                <div className={textStyles.lsCont}>
                    <ul>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Подача заявления на перенос номера новому оператору</div>
                            </div>
                        </li>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Проверка персональных данных на соответствие данным у исходного оператора</div>
                            </div>
                        </li>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Выдача SIM карты  нового оператора с уже нужным тарифом</div>
                            </div>
                        </li>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Ожидание перехода ( примерно 10 дней )</div>
                            </div>
                        </li>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>На SIM карту нового оператора переносится Ваш исходный номер. Ваша старая сим карта перестанет работать</div>
                            </div>
                        </li>
                    </ul>

                </div>
                <hr className={textStyles.hr}></hr>
                <p className={textStyles?.ident}>
                    Исходный оператор оставляет за собой право отказать в реализации процедуры MNP по переносу номера. После устранения причин отказа процедура может быть возобновлена.
                </p>
                <div className={textStyles.cenCont}><p className={textStyles.bold}>Причины отказа в процедуре переноса номера:</p></div>
                <p>
                    <span className={textStyles.bold}>Несоответствие данных:</span>
                        при заполнении заявления необходимо указать те персональные данные, которые вносились на момент регистрации Вашей SIM карты. Замена паспорта, смена фамилии, прописки могут быть причиной отказа.
                    <div className={textStyles.itel}>
                        <span className={textStyles.bold}>Решение:</span>
                            актуализация данных у Вашего оператора. Осуществляется в салоне связи, звонком в службу поддержки Вашего оператора или в мобильном приложении оператора с использованием сервиса Госуслуги. После актуализации процедуру переноса номера можно запустить повторно.
                    </div>
                </p>


                <p>
                    <span className={textStyles.bold}>Запрет на подключение SIM карт в сервисе «Госуслуги»:</span>
                    У Вас установлен запрет на подключение новых SIM карт в профиле «Госуслуг», что не дает возможности подключить временный номер
                    <div className={textStyles.itel}>
                        <span className={textStyles.bold}>Решение :</span>
                        Отключить данный запрет, после процедуры портации, Вы можете вновь его установить
                    </div>
                </p>

                <p>
                    <span className={textStyles.bold}>SIM карта является корпоративной:</span>
                        SIM карта является корпоративной и оформлена на юридическое лицо, а человек вносит свои персональные данные, что не соответствует данным у оператора. В этом случае также будет отказ. Убедиться в том, что SIM карта оформлена на Вас можно просто позвонив в службу поддержки оператора мобильной связи.
                    <div className={textStyles.itel}>
                        <span className={textStyles.bold}>Решение :</span>
                        переоформление SIM карты на свои персональные данные. После переоформления процедуру переноса номера можно запустить повторно.
                    </div>
                </p>




                <p>
                    <span className={textStyles.bold}>Прошло менее 60 дней последней процедуры переноса номера:</span>
                    процедура смены оператора связи может осуществляться не чаще, чем один раз в 60 дней от даты последнего перехода.
                    <div className={textStyles.itel}>
                        <span className={textStyles.bold}>Решение:</span>
                        повторная подача заявления на перенос номера по истечению 60 дней.
                    </div>
                </p>

                <p>
                    <span className={textStyles.bold}>Долг перед Вашим оператором:</span>
                    попытка провести процедуру переноса номера, имея задолженность перед Вашим оператором, или не оплаченные услуги, например, обещанный платеж и т.п.
                    <div className={textStyles.itel}>
                        <span className={textStyles.bold}>Решение:</span>
                        оплата задолженности. После этого процедуру переноса номера можно запустить повторно.

                    </div>
                </p>

                <p>
                    <span className={textStyles.bold}>Отказ пользователя:</span>
                        в процессе перехода, пользователь сам отказывается от этой процедуры, например из-за того, что исходный оператор в процессе перехода предлагает изменить условия тарифа на более выгодные. В таком случае, договор с нашей стороны считается исполненным надлежащим образом и денежные средства не возвращаются. Следует помнить, что  исходный оператор предлагает изменить условия на некоторое время ( 3-6 месяцев ), а затем вернет прежние.
                    <div className={textStyles.itel}>

                </div>
                </p>


                <hr className={textStyles.hr}></hr>
                <p className={textStyles?.ident}>
                    При переходе следует иметь в ввиду, что новый оператор взимает единоразовый платеж за процедуру MNP в размере около 150 руб. Эти средства списываются уже с новой SIM карты. Эти средства списывает оператор
                    и наш интернет магазин не имеет к этому отношения.
                </p>
                <p className={textStyles?.ident}>
                    Если процесс доставки занимает более 10 дней  ( времени прохождения процедуры MNP ), желательно заказать доставку в салон оператора, если имеется такая возможность, так как появляется риск
                    «остаться без связи», из-за того, что процедура завершится, Ваша исходная карта отключится, а новая будет еще в пути.
                </p>
                <p className={textStyles?.ident}>
                    Процедура MNP всегда проводится только после консультации с клиентом по номеру, который учавствует в процедуре, для исключения недопониманий - все звонки записываются.
                </p>
                <hr className={textStyles.hr}></hr>
                <div className={textStyles.cenCont}><p className={textStyles.bold}>Как запустить процедуру MNP на сайте</p></div>
                <p className={textStyles?.ident}>
                    Не все тарифы поддерживают процедуру MNP. В карточке тарифов, которые позволяют это сделать будет пометка. Находим нужный тариф и нажимаем кнопку проверить
                </p>
                <div className={textStyles.cenCont}>
                    <div className={textStyles.imgCont}>
                        <img className={textStyles.widthImg} src={exSTEP1}></img>
                        <div className={textStyles.imgTitle}>Рисунок 2. (Наличие MNP у тарифа)</div>
                    </div>
                </div>
                <p className={textStyles?.ident}>
                    Далее нужно проверить возможность перейти со своим номером, вбиваем свой номер в поле и нажимаем проверить, если проверка пройдет отобразится кнопка «перейти», нажимаем ее
                    и следуем инструкциям
                </p>
                <div className={textStyles.cenCont}>
                    <div className={textStyles.imgCont}>
                        <img className={textStyles.widthImg} src={exSTEP2}></img>
                        <div className={textStyles.imgTitle}>Рисунок 3. (Проверка возможности для своего номера)</div>
                    </div>
                </div>


            </div>
        </div>
    )
}